/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Informationen zur Auswahl eines Zaehlers
 */
export interface VertragsIdentifierInner { 
    sparte?: string;
    contractId?: string;
    imsys?: boolean;
}

